import React from 'react'

const SvgEyeFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M2 12c0-.93.654-1.452.654-1.452C5.855 7.516 8.99 6.005 11.995 6c3.006-.005 6.17 1.516 9.37 4.548 0 0 .63.522.63 1.452 0 .93-.608 1.43-.608 1.43-3.21 3.047-6.387 4.565-9.392 4.57-3.004.005-6.142-1.517-9.344-4.551 0 0-.651-.519-.651-1.449zm9.995 4c2.214 0 4-1.786 4-4s-1.786-4-4-4c-2.213 0-4 1.786-4 4s1.787 4 4 4zm2-4a2.001 2.001 0 11-4.002-.001 2.001 2.001 0 014.002.001z' />
  </svg>
)

export default SvgEyeFilled
